import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProductInfo, getRecommendations } from "../actions/ApiCalls";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import './Brands.css'
import ProductFilter from "../Components/ProductFilter";

function Products() {
    const { brand, product } = useParams<{ brand?: string, product?: string }>();

    const [productInfo, setProductInfo] = useState<any>(null);
    const [recommendedProducts, setRecommendedProducts] = useState<any[]>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [imageMaxWidth, setImageMaxWidth] = useState("220px");
    const mainImageRef = useRef<HTMLImageElement>(null);


    const navigate = useNavigate();

    const handleImageClick = (productSearchName: string) => {
        if (brand) {
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
            navigate(`/our-wines/${brand}/${productSearchName}`);
        }
    };

    const [filterMode, setFilterMode] = useState<'hidden' | 'scroll' | 'fixed'>('hidden');
    const filterRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setFilterMode('scroll');
                } else {
                    setFilterMode('fixed');
                }
            },
            { threshold: 0.1 }
        );

        if (filterRef.current) {
            observer.observe(filterRef.current);
        }

        return () => {
            if (filterRef.current) {
                observer.unobserve(filterRef.current);
            }
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProductInfo();
        fetchRecommendedProducts();

        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [brand, product]);

    useEffect(() => {
        const img = mainImageRef.current;
        if (!img) return;

        const handleLoad = () => {
            const aspectRatio = img.naturalHeight / img.naturalWidth  ;

            if (window.innerWidth < 576) {
                setImageMaxWidth("250px"); // Always cap at 250px on mobile
            } else {
                setImageMaxWidth(aspectRatio < 1.5 ? "450px" : "220px");
            }
        };

        if (img.complete) {
            handleLoad();
        } else {
            img.addEventListener("load", handleLoad);
            return () => img.removeEventListener("load", handleLoad);
        }
    }, [productInfo?.image_path, windowWidth]);

    function fetchProductInfo() {
        if (product) {
            getProductInfo(product)
                .then(response => setProductInfo(response.data))
                .catch(error => console.error("Failed to fetch product info:", error));
        }
    }

    function fetchRecommendedProducts() {
        if (product && brand) {
            getRecommendations(brand, product)
                .then(response => setRecommendedProducts(response.data))
                .catch(error => console.error("Failed to fetch recommended products:", error));
        }
    }

    const wineURL = 'https://vinimark.s3.amazonaws.com/web/';

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

        <Header />
            <div style={{ marginTop: '70px' }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: windowWidth > 576 ? 'row' : 'column',
                        gap: '20px',
                        padding: '20px',
                        marginBottom: '100px',
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            ref={mainImageRef}
                            src={`${wineURL}${productInfo?.image_path}`}
                            alt={productInfo?.name}
                            style={{
                                maxWidth: imageMaxWidth,
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                maxHeight: windowWidth > 576 ? '85vh' : '70vh',
                            }}
                        />
                    </div>


                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            padding: windowWidth > 576 ? '0 20px' : '20px',
                            marginTop: windowWidth > 576 ? '140px' : '0',
                            marginLeft: windowWidth > 576 ? '26px' : '0',
                        }}
                    >
                        {productInfo?.brand && windowWidth > 576 && (
                            <img
                                src={`${wineURL}${productInfo.brand.image_path}`}
                                alt={productInfo.brand.name}
                                style={{ width: '170px', cursor: 'pointer' }}
                                onClick={() => navigate(`/our-wines/${productInfo?.brand?.search_name}`)}
                            />
                        )}

                        <p style={{
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            marginBottom: 0,
                            marginTop: windowWidth > 576 ? '50px' : '0'
                        }}>
                            {productInfo?.name}
                        </p>
                        <p style={{
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            marginTop: 0
                        }}>
                            {productInfo?.year}
                        </p>
                        <p style={{
                            width: windowWidth > 576 ? '70%' : '100%',
                            marginBottom: '20px',
                            marginTop: '20px'
                        }}>
                            {productInfo?.description}
                        </p>

                        <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                            <a
                                href={`${wineURL}${productInfo?.tasting_note_path}`}
                                className="brand-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                tasting note
                            </a>
                            <a
                                className="brand-link"
                                href={`${wineURL}${productInfo?.image_path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Hi-res image
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '24px', textAlign: 'left', paddingLeft: '24px' }}>
                    More from{" "}
                    <a
                        href={`/our-wines/${productInfo?.brand?.search_name}`}
                        style={{ color: 'black', textDecoration: 'none' }}
                    >
                        {productInfo?.brand?.name}
                    </a>
                </div>

                <div
                    style={{
                        display: 'flex',
                        gap: '20px',
                        marginTop: '20px',
                        paddingLeft: '24px',
                        overflowX: 'auto',
                        flexWrap: 'nowrap'
                    }}
                >
                    {recommendedProducts.map((product: any) => (
                        <div
                            key={product.id}
                            style={{
                                flex: windowWidth < 575 ? '0 0 135px' : '0 0 25%',
                                minWidth: '100px',
                                maxWidth: windowWidth >= 575 ? '400px' : '135px',
                                textAlign: 'center',
                                paddingBottom: '30px',
                                boxSizing: 'border-box',
                            }}
                        >
                            <div
                                style={{
                                    width: '100%',
                                    backgroundColor: '#f5f5f5',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: windowWidth < 575 ? '0' : '30px 0',
                                    height: windowWidth < 575 ? '200px' : 'auto',
                                }}
                                onClick={() => handleImageClick(product.search_name)}
                            >
                                <img
                                    src={wineURL + product.image_path}
                                    alt={product.name}
                                    style={{
                                        width: '90%',
                                        maxHeight: windowWidth >= 575 ? '450px' : '135px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                            {/*<p style={{*/}
                            {/*    fontWeight: 400,*/}
                            {/*    textTransform: 'uppercase',*/}
                            {/*    marginBottom: 0,*/}
                            {/*    fontSize: windowWidth < 575 ? '10px' : 'inherit'*/}
                            {/*}}>*/}
                            {/*    {productInfo?.brand?.name}*/}
                            {/*</p>*/}
                            <p style={{
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                marginTop: 0,
                                marginBottom: 0,
                                fontSize: windowWidth < 575 ? '10px' : 'inherit'
                            }}>
                                {product.name}
                            </p>
                            <p style={{
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                marginTop: 0,
                                marginBottom: 0,
                                fontSize: windowWidth < 575 ? '10px' : 'inherit'
                            }}>
                                {product.year}
                            </p>
                        </div>
                    ))}
                </div>
                {/* Product Filter */}
                <div ref={filterRef} style={{ width: '100%' }}>
                    <ProductFilter
                        mode={filterMode}
                        additionalFields={true}
                        brand={productInfo?.brand?.name}
                    />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Products;
